/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, RestSettings, identity } from '@gh/core-data';
import { Observable } from 'rxjs';
import { BulkUsageResponse, UsageDto, UsageEntityType } from './usage.dto';
import { UsageMapper } from './usage.mapper';

@Injectable()
export class UsageRestService extends AbstractRestService {
  constructor(settings: RestSettings) {
    super(settings);
  }

  getUsageInfo(entityId: ID, entryPoint: UsageEntityType): Observable<UsageDto> {
    return this.httpGet(`${this.bp}/usage/info`, { entityId, entryPoint: UsageEntityType[entryPoint] }, void 0, UsageMapper);
  }

  getBulkUsageInfo(entityList: any[], entryPoint: string): Observable<BulkUsageResponse> {
    return this.httpPost(`${this.bp}/${entryPoint}/check-usage`, entityList, identity(), identity());
  }
}
